/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll, getById } from "../../../utils/requests/dynamicReq";
import { paths } from "../../../utils/paths";

import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Form, InputGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import { IStore } from "../../../interfaces/IStore";
import { IUser } from "../../../interfaces/IUser";

interface IEntidadParticipanteShort {
  id: string;
  nombre: string;
}

export const EntidadParticipante: FC = () => {
  const history = useHistory();

  let { staffId, isAdmin, userRoleId } = useSelector(({ user }: IStore) => user as IUser);  

  const [isLoading, setIsLoading] = useState(false);

  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { ENTIDAD_PARTICIPANTE, INVESTIGATORS } = paths;
  const [entidadesParticipantes, setEntidadesParticipantes] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [filteredEntidadesParticipantes, setFilteredEntidadesParticipantes] = useState<IEntidadParticipanteShort[]>([]);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    try {
      isMountedRef.current && loadEntidadesParticipantes();
    } catch (error) {
      console.log(error);
      console.log("HTTP call cancelled");
    }
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const loadEntidadesParticipantes = async () => {
    try {
      if (isAdmin) {
        const response = await getAll(ENTIDAD_PARTICIPANTE, source);
        if (isMountedRef.current) {
          filterEntidadesParticipantes(response);
        }
      } else if (!isAdmin) {
        let id = staffId.toString();
        const investigator = await getById(INVESTIGATORS, id, source);
        if (isMountedRef.current) {
          filterEntidadParticipanteByInvestigator(investigator);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const filterEntidadesParticipantes = (rawEntidadesParticipantes: any[]) => {
    let entidadesParticipantes: IEntidadParticipanteShort[] = rawEntidadesParticipantes.map(
      ({ id, nombre }: IEntidadParticipanteShort) => ({
        id,
        nombre,
      })
    );
    setEntidadesParticipantes(entidadesParticipantes);
    setFilteredEntidadesParticipantes(entidadesParticipantes);
  };

  const filterEntidadParticipanteByInvestigator = (rawEntidadesParticipantes: any) => {
    // console.log(rawGroups.investigationGroup);
    if (!!rawEntidadesParticipantes.investigationGroup) {
      let entidadesParticipantes: IEntidadParticipanteShort[] = [
        {
          id: rawEntidadesParticipantes?.investigationGroup?.id,
          nombre: rawEntidadesParticipantes?.investigationGroup?.tituloEs,
        },
      ];
      setEntidadesParticipantes(entidadesParticipantes);
      setFilteredEntidadesParticipantes(entidadesParticipantes);
    }
  };

  const handleSearch = (value: any) => {
    setSearch(value);
    setFilteredEntidadesParticipantes(
      entidadesParticipantes.filter(({ nombre }: any) =>
        nombre.toLowerCase().includes(value.toLowerCase())
      )
    );
    !value && setFilteredEntidadesParticipantes(entidadesParticipantes);
  };

  return (
    <div className="container-fluid p-4">
      {!isAdmin && userRoleId !== 3 ? (
        <>Usted no tiene acceso</>
      ) : (
        <>
          {" "}
          <div className="row">
            <div className="col-12 d-flex justify-content-between">
              <h3>Entidades participantes</h3>
              <div>
                {(isAdmin || userRoleId === 3) && (
                  <button
                    className="baseBtn"
                    onClick={() => history.push(`${ROUTES.EntidadesParticipantes.create}`)}
                  >
                    + Añadir
                  </button>
                )}
              </div>
            </div>
          </div>
          {/* <div className="center flex-column justify-content-around text-center p-5 mt-2"> */}
          <div className="row mt-4">
            <Form.Group as={Col}>
              <InputGroup className="shadow">
                <InputGroup.Prepend>
                  <InputGroup.Text className="inputGroup ">
                    <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Buscar..."
                  className="form-control"
                  value={search}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </InputGroup>
            </Form.Group>
          </div>
          <div className="row">
            <div className="col-12 ">
              <table className="table table-hover">
                <tbody>
                  {filteredEntidadesParticipantes?.map(
                    ({ id, nombre }: IEntidadParticipanteShort, index: number) => (
                      <tr
                        key={index}
                        className="pointer"
                        onClick={() =>
                          history.push(`${ROUTES.EntidadesParticipantes.all}/${id}`)
                        }
                      >
                        <td>{`${nombre}`}</td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
              {isLoading && (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border mt-5" role="status" />
                </div>
              )}

              {!filteredEntidadesParticipantes.length && !isLoading && isAdmin && (
                <div className="d-flex justify-content-center mb-3">
                  <h5>-No existen entidades-</h5>
                </div>
              )}

              {!filteredEntidadesParticipantes.length && !isLoading && !isAdmin && (
                <div className="d-flex justify-content-center mb-3">
                  <h5>-No pertenece a ningúna entidad-</h5>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
    // </div>
  );
};
